module.exports = __webpack_public_path__ + "img/box-3-en.e7fea6ef.png";